import React from 'react';
import { ReactComponent as CommentAdd } from '../../assets/icons/commentAdd.svg';
import { ReactComponent as CommentAddContrast } from '../../assets/icons/commentAddContrast.svg';
import TooltipOneComponent from '../TooltipOne/TooltipOne.component';
import { useLayoutContext } from '../../Context/Layout.context';
import { IconButton } from '@material-ui/core';
import { useStyles } from './CommentIcon.styles';

export const ADD_ICON_DRAG_TYPE = 'ADD_ICON_DRAG_TYPE';
export interface CommentIconProps {
  onCommentActiveChange: (isActive: boolean) => void;
  isActive: boolean;
}

const CommentIcon: React.FC<CommentIconProps> = ({ onCommentActiveChange, isActive }) => {
  const { highContrastMode } = useLayoutContext();
  const classes = useStyles();

  return (
    <TooltipOneComponent title="Dodaj komentarz" placement="right">
      <div className={isActive ? classes.activeWrapper : undefined}>
        <IconButton disableRipple className={classes.iconButton} onClick={() => onCommentActiveChange(!isActive)}>
          {highContrastMode ? (
            <CommentAddContrast style={{ pointerEvents: 'none' }} />
          ) : (
            <CommentAdd style={{ pointerEvents: 'none' }} />
          )}
        </IconButton>
      </div>
    </TooltipOneComponent>
  );
};

export default CommentIcon;
